import React, { Component } from 'react';
import axios from 'axios';
import { Navigate } from 'react-router-dom';
import AvatarEditor from 'react-avatar-editor';
import '../css/TestimonialForm.css';
import '../css/Form.css';
import '../css/UserStyle.css'
import EditUserInfoRow from '../components/EdirUserInfoRow';
import UserInfoRow from '../components/UserInfoRow';
import PhoneNumberInput from '../components/PhoneNumberInput';
import { fetchUserData } from '../../../config/UserDetailsFetch';
import { NavLink } from 'react-router-dom';
import { Save } from 'react-feather';
import Loading from '../components/Loading';
import SuccessIcon from '../components/SuccessIcon';

class EditUserSettings extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            image: null,
            scale: 1,
            allowZoomOut: false,
            rotate: 0,
            position: { x: 0, y: 0 },
            preview: null,
            width: 250,
            height: 250,
            user: props.user,
            joiningDate: '',
            days: 0,
            months: 0,
            years: 0,
            resignDate: null,
            method: 'insert', // Assuming default method is 'insert'
            isLoading: false,
            mobileLoading: false,
            mobileExists: null,
            mobileExistsMessage: null,
            emailLoading: false,
            emailExists: null,
            emailExistsMessage: null, 
            emailNotValid:null,
            userDetailsBak : null,
            userDetails: {
                id: '',
                personal_email: '',
                mobile_ISD : '91',
                mobile: '',
                name: '',
                middle_name: '',
                last_name: '',
                role: '',
                address_1: '',
                address_2: '',
                address_3: '',
                city: '',
                state: '',
                pincode: '',
                image: null,
                join_date: null,
                resign_date: '',
                user_type: null,
                user_level: null,
                method: '',
                image_loc: null,
                scale: null,
                position_x: null,
                position_y: null,
                rotate: null,
                id_proof_file_2 : null,
                
            },

        };
        this.editorRef = React.createRef();
        this.rotateInputRef = React.createRef();
        this.scaleInputRef = React.createRef();
    }






    calculateDuration = (joiningDate, resignDate) => {
        const joinDate = new Date(joiningDate);
        const specifiedDate = resignDate ? new Date(resignDate) : new Date();

        // Calculate the difference in milliseconds
        const diffTime = Math.abs(specifiedDate - joinDate);
        // Convert milliseconds to days
        const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));

        // Calculate years
        const years = Math.floor(diffDays / 365);
        // Calculate remaining days
        const remainingDays = diffDays % 365;

        // Calculate months based on remaining days
        const months = Math.floor(remainingDays / 30);
        // Calculate remaining days
        const days = remainingDays % 30;

        this.setState({ years, months, days });

    };
    async componentDidMount() {

        const { user } = this.props; // Extract the user prop

        const postId = localStorage.getItem('postId');
        const userType = localStorage.getItem('userType');

        //const userId = user.id; // Extract just the ID from the user object
        try {
            
            this.setState({ isLoading: true });
            const data = await fetchUserData(postId, userType); // Pass only the ID to fetchUserData
            const combinedObj = { ...data[0]};

            
            

            if (combinedObj && Object.keys(combinedObj).length > 0)  {

                if (combinedObj.image) {
                    combinedObj.image = `https://yesedacademy.com/database/${combinedObj.image}`;
                }


                this.setState({
                    userDetails: combinedObj,
                    userDetailsBak: combinedObj,
                    method: 'update',
                    scale: combinedObj.scale,
                    rotate: combinedObj.rotate,
                    position: { x: combinedObj.position_x, y: combinedObj.position_y }
                }, () => {
                    //console.log('data ssfound :', user); 
                    localStorage.removeItem('postId');
                    const { userDetails } = this.state;
                    const joiningDate = new Date(userDetails.join_date);
                    const resignDate = userDetails.resign_date ? new Date(userDetails.resign_date) : null;
                    this.setState({ joiningDate, resignDate }, () => {
                        this.calculateDuration(this.state.joiningDate, this.state.resignDate);
                    });
                });
                //console.log('data found :', user); 
            } else {
                console.log('No data found for id:', user); // Log the user ID
            }
        } catch (error) {
            console.error('Error fetching user data:', error);
        } finally {
            this.setState({ isLoading: false });
        }








    }



    handleDateChange = (event) => {
        this.setState({ joiningDate: event.target.value });
    };

    handleInputChange = (e) => {
        this.setState({ [e.target.name]: e.target.value });
    };

    handleInput = (e) => {
        const { name, value } = e.target;
        let sanitizedValue = value === null ? '' : value;

        if (name === 'mobile') {
            this.checkMobileExists(sanitizedValue, this.state.userDetails.mobile_ISD);
        }
        if (name === 'mobile_ISD') {
            this.checkMobileExists(this.state.userDetails.mobile, sanitizedValue);
        }
        if (name === 'personal_email') {
            this.checkEmailExists(sanitizedValue);
        }

        this.setState(prevState => ({
            userDetails: {
                ...prevState.userDetails,
                [name]: sanitizedValue
            }

        }), () => {

            //console.log('Date', this.state.joiningDate);

        });

    };

    checkMobileExists = (mobile, isd) => {
        console.log("mobile isd : ", isd,mobile);
        this.setState({ mobileLoading: true, mobileExists: null, mobileExistsMessage: null  });

        if (!/^\d*$/.test(mobile)) {
            this.setState({ mobileExists: false, saveDisabled: false, mobileLoading: false })

        }
        else {
       
        axios.get(`https://yesedacademy.com/database/check_mobile.php?isd=${isd}&mobile=${mobile}`)
            .then(response => {
                if (response.data.exists){
                    mobile !== this.state.userDetailsBak.mobile ?  this.setState({ mobileExists: true, mobileExistsMessage: true, saveDisabled: true, mobileLoading: false }) : this.setState({ mobileExists: false, mobileExistsMessage: false, saveDisabled: false, mobileLoading: false });
                } else {
                    this.setState({ mobileExists: false,  mobileExistsMessage: false, saveDisabled: false, mobileLoading: false });
                }
            })
        
            .catch(error => {
                console.error('There was an error checking the mobile number!', error);
                this.setState({ mobileLoading: false });
            });
        }
        
    };

    checkEmailExists = (personal_email) => {
        this.setState({ emailLoading: true, emailExists: null, emailExistsMessage: null, emailNotValid:null });

        if (/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(personal_email)) {
            this.setState({ emailNotValid: false, saveDisabled: false, emailLoading: false, emailExists: false });
            /*this.setState(prevState => ({
                userDetails: { ...prevState.userDetails, personal_email:null }
            }));*/
            
        }
        else if(personal_email === '') {
            this.setState({ emailNotValid: false, saveDisabled: false, emailLoading: false , emailExists: false});
        }
        else{
            this.setState({ emailNotValid: true, saveDisabled: true, emailLoading: false, emailExists: true });
        }
       
            
        
    };



    handleImageChange = (e) => {
        const allowedTypes = ['image/jpeg', 'image/jpg', 'image/png'];
        const file = e.target.files[0];
        const reader = new FileReader();

        reader.onload = () => {
            const image = reader.result;
            //console.log('newww image : ', image);
            this.setState(prevState => ({
                StudentData: {
                    ...prevState.StudentData,
                    //image: reader.result || prevState.StudentData.image
                    image: image
                }
            }), () => {
                //console.log('image changed : ',image)
                // Call updatePreview after setting the image with a slight delay
                setTimeout(() => {
                    this.updatePreview();
                }, 100);

            });
        };

        if (file && allowedTypes.includes(file.type)) {
            reader.readAsDataURL(file);
        } else {
            // Notify the user that only JPG, JPEG, and PNG files are allowed
            alert('Please select a valid image file (JPG, JPEG, or PNG).');
            // Reset the file input value to prevent selecting an invalid file
            e.target.value = null;
            // Reset the avatar image to the database image if available, otherwise set it to null


            const updated_image = this.state.DatabaseImg.images;
            const databaseImage = updated_image ? updated_image : null;
            //console.log('new image e: ', updated_image);
            this.setState(prevState => ({
                StudentData: {
                    ...prevState.StudentData,
                    image: databaseImage
                }

            }), () => {
                //console.log('Image updatedddd:', this.state.StudentData.image);
                // Call updatePreview to reflect the change
                this.updatePreview();
            });
        }


    };


    handleZoomIn = () => {
        this.setState((prevState) => ({ scale: Math.min(prevState.scale + 0.1, 8) }), () => {
            this.updatePreview(); // Call updatePreview after zoom in
        });

    };

    handleZoomOut = () => {
        this.setState((prevState) => ({ scale: Math.max(prevState.scale - 0.1, 1) }), () => {
            this.updatePreview(); // Call updatePreview after zoom out
        });
    };

    handleXPosition = (e) => {
        const x = parseFloat(e.target.value);
        this.setState({ position: { ...this.state.position, x } }, () => {
            this.updatePreview(); // Call updatePreview after changing X position
        });
    };

    handleYPosition = (e) => {
        const y = parseFloat(e.target.value);
        this.setState({ position: { ...this.state.position, y } }, () => {
            this.updatePreview(); // Call updatePreview after changing Y position
        });
    };

    setEditorRef = editor => {
        if (editor) {
            this.editor = editor;
            this.updatePreview();
        }
    }

    handlePositionChange = position => {
        this.setState({ position });
    }

    rotateLeft = (e) => {
        e.preventDefault();
        this.setState({
            rotate: this.state.rotate - 90
        },
            () => {
                this.updatePreview(); // Call updatePreview after rotating left
            }
        );
    }

    rotateRight = (e) => {
        e.preventDefault();
        this.setState({
            rotate: this.state.rotate + 90
        },
            () => {
                this.updatePreview();
            }
        );
    }

    handleScale = (e) => {
        const scale = parseFloat(e.target.value);
        this.setState({ scale }, () => {
            this.updatePreview();
        });
    }

    handleScaleInputChange = (e) => {
        let newScale = parseFloat(e.target.value);
        // Ensure the new scale value is within the allowed range
        if (newScale < (this.state.allowZoomOut ? 0.1 : 1)) newScale = this.state.allowZoomOut ? 0.1 : 1;
        if (newScale > 8) newScale = 8;
        this.setState({ scale: newScale }, () => {
            this.handleScale({ target: { value: newScale } });
        });
    };

    handleRotateChange = (e) => {
        const rotate = parseFloat(e.target.value);
        this.setState({ rotate }, () => {
            this.updatePreview();
        });
    };

    handleRotateNumberChange = (e) => {
        let newRotate = parseInt(e.target.value, 10);
        if (newRotate < -180) newRotate = -180;
        if (newRotate > 180) newRotate = 180;
        this.setState({ rotate: newRotate });
    };


    updatePreview = () => {

        const img = new Image();
        img.src = this.editor.getImageScaledToCanvas().toDataURL();

        img.onload = () => {
            const canvas = document.createElement('canvas');
            canvas.width = img.width;
            canvas.height = img.height;
            const ctx = canvas.getContext('2d');

            ctx.drawImage(img, 0, 0);

            const jpgImage = canvas.toDataURL('image/jpeg', 0.8);
            //console.log("image :" ,  );

            this.setState({
                preview: {
                    img: jpgImage,
                    scale: this.state.scale,
                    width: 250,
                    height: 250,
                }
            }, () => {
                const { x, y } = this.state.position;
                this.setState({ x, y });
                //this.convertBase64ToBlob();
                console.log('Image pre : ', this.state.preview.img);
                //this.handleImageConvert();
            });
        };
    };



    render() {

       
        const { userDetails, userDetailsBak, isLoading, mobileExists, mobileExistsMessage, mobileLoading, emailNotValid, emailLoading, saveDisabled } = this.state;
        const { joiningDate, resignDate, years, months, days } = this.state;
        let duration;

  if (years > 0) {
    duration = `${years} year${years > 1 ? 's' : ''}, ${months} month${months > 1 ? 's' : ''}, ${days} day${days > 1 ? 's' : ''}`;
  } else if (years == 0 && months > 0) {
    duration = `${months} month${months > 1 ? 's' : ''}, ${days} day${days > 1 ? 's' : ''}`;
  } else {
    duration = `${days} day${days > 1 ? 's' : ''}`;
  }
  console.log("data : ", this.state.userDetails)


        return (


            <div>
                {isLoading ? (
                   <Loading size={100} />
                ) : userDetailsBak ? (

                    <div>
                         <form id="create_testimonial"
                            name="create_testimonial"
                            action="https://yesedacademy.com/database/user-settings_update.php"
                            method="post"
                            encType="multipart/form-data"
                        >
                        <div className="container" >
                                <div className="row mt-2" >

                                    <div className="col-md-11"></div>
                                    <div className="col-md-1 align-items-right">
                                        <div className="d-flex justify-content-start align-items-center ">
                                        <div>
                                                <button className='no-hover' onClick={this.handleSave} id="insert" name="insert" type='submit' disabled={saveDisabled}>
                                                    <Save className='ico-button' aria-label="Edit" /> Save</button>
                                            </div>
                                            <span className='p-3'>  </span>
                                           {/* 
                <NavLink  to='/user-settings' label='Edit'>
                                    <Save className='ico-button' />
                                </NavLink>
                <span className='p-3'>  </span>*/}

                                        </div>
                                    </div>
                                </div>
                            </div>

                    <div className="container rounded bg-white mt-5 mb-5">
                        <div className="row">
                            <div className="col-md-15 border-right">
                                <div className="d-flex flex-column align-items-center text-center p-3 py-5">
                                <h4 className="text-right">Profile Picture</h4>



{this.state.userDetails.image && (
    <div>

        <AvatarEditor
            ref={this.setEditorRef}
            scale={parseFloat(this.state.scale)}
            onScaleChange={(scale) => {
                this.setState({ scale });
                this.updatePreview();
            }}
            position={this.state.position}
            onPositionChange={(position) => {
                this.setState({ position });
                this.updatePreview();
            }}
            rotate={parseFloat(this.state.rotate)}
            onRotateChange={(rotate) => {
                this.setState({ rotate });
                this.updatePreview();
            }}
            //image={ this.state.StudentData.method === 'insert' ? this.state.StudentData.image : this.state.StudentData.image_loc }
            image={this.state.userDetails.image}
            width={250}
            height={250}
            border={0}
            color={[255, 255, 255, 0.6]}
            className="avatar-editor"
            crossOrigin="anonymous"
            borderRadius={250 / 2}
            onImageChange={this.state.updatePreview}
            onLoad={() => this.setState({ imageLoaded: true })}

        />

        <div className="zoom-controls ">
            Zoom
            <br></br>
            <input className='range-input'
            name="scale" type="range" onChange={this.handleScale}
                min={this.state.allowZoomOut ? "0.1" : "1"}
                max="8"
                step="0.01"
                //defaultValue={this.state.StudentData.scale !== null ? this.state.StudentData.scale : "1"}
                value={this.state.scale}
                ref={this.scaleInputRef}

            />
            <input
                className="number-input"
                type="number"
                value={this.state.scale}
                style={{ width: '70px' }}
                onChange={this.handleScaleInputChange}
                step="0.01"
                min={this.state.allowZoomOut ? "0.1" : "1"}
                max="8"
            />
        </div>
        <div className="zoom-controls ">

            Rotate
            <br></br>
            <input
                className='range-input'
                type="range"
                id="rotate"
                name="rotate"
                min="-180"
                max="180"
                step="1"
                value = {this.state.rotate}
                //defaultValue={this.state.StudentData.rotate !== null ? this.state.StudentData.rotate : "0"}
                // defaultValue="0"
                onChange={this.handleRotateChange}
                ref={this.rotateInputRef}
            /> 
            <input
            className="number-input"
            type="number"
            value={this.state.rotate}
            style={{ width: '70px' }}
            onChange={this.handleRotateNumberChange}
            step="1"
            min="-180"
            max="180"
            
        />

        </div>
        {this.state.preview && (

            <input type="text" name="photo" id="photo" hidden value={this.state.preview.img} />


        )}
    </div>
)}
<div className="col-md-14"><input type="file" name='image' id='image' className="form-control" onChange={this.handleImageChange}
    required={this.state.userDetails.image === null} /></div>
                                </div>
                            </div>
                            <div className="col-md-16 border-right">
                                <div className="p-3 py-5">
                                    <div className="d-flex justify-content-between align-items-center mb-3">
                                        <h4 className="text-right">Personal Information</h4>
                                    </div>
                                    <div className="row mt-2">
                                                <div className="col-md-12"><label className="labels">Name *</label></div>
                                                <div className="col-md-18 mt-1">
                                                    <input type="text" className="form-control" id='name' name='name' value={userDetails.name} placeholder='First Name *' required onChange={this.handleInput} />
                                                </div>

                                                <div className="col-md-19 mt-1">
                                                    <input type="text" className="form-control" id='middle_name' name='middle_name' value={userDetails.middle_name} placeholder='Middle Name' onChange={this.handleInput} />
                                                </div>

                                                <div className="col-md-20 mt-1">
                                                    <input type="text" className="form-control" id='last_name' name='last_name' value={userDetails.last_name} placeholder='Last Name *' required onChange={this.handleInput} />
                                                </div>
                                            </div>
                                    <PhoneNumberInput type="number" label="Mobile *" id="mobile" value={userDetails.mobile} value_ISD={userDetails.mobile_ISD} required="required" onChange={this.handleInput} status={<SuccessIcon loading={mobileLoading} exists={mobileExists} />} />
                                    {mobileExistsMessage === true && (
                                                <div className="text-danger mt-2">Mobile number already exists.</div>
                                            )}
                                    <EditUserInfoRow type="text" id="personal_email" label="Email"  value={userDetails.personal_email} onChange={this.handleInput} status={<SuccessIcon loading={emailLoading}  valid={emailNotValid}  />} />
                                    {emailNotValid === true && (
                                                <div className="text-danger mt-2">Not a valid email address</div>
                                            )}
                                    <EditUserInfoRow label="Address" id='address_1' name='address_1' value={userDetails.address_1}  onChange={this.handleInput} />
                                    <EditUserInfoRow id='address_2' name='address_2' value={userDetails.address_2}  onChange={this.handleInput} />
                                    <EditUserInfoRow id='address_3' name='address_3' value={userDetails.address_3}  onChange={this.handleInput} />
                                    <EditUserInfoRow id='city' name='city' label="City" value={userDetails.city}  onChange={this.handleInput} />
                                    <EditUserInfoRow id='state' name='state' label="State" value={userDetails.state}  onChange={this.handleInput} />
                                    <EditUserInfoRow id='pincode' name='pincode' label="Pincode" value={userDetails.pincode}  onChange={this.handleInput} />

                                </div>
                            </div>
                            <div className="col-md-17">
                                
                                <div className="p-3 py-5">
                                    <div className="d-flex justify-content-between align-items-center mb-3">
                                        <h4 className="text-right">Job Information</h4>
                                    </div>
                                    <UserInfoRow label="Role" data={userDetails.role} />
                                    <UserInfoRow label="Email" data={userDetails.email_address} />
                                    <UserInfoRow label="Date of Joining" data={joiningDate ? joiningDate.toDateString() : ""} />
                                    <UserInfoRow label="Duration" data={duration} />


                                    {resignDate ? <div><UserInfoRow label="Resigned Date" data={resignDate.toDateString()} /> <UserInfoRow label="Status" data="Resigned" style={{ color: 'red' }} /></div> : <UserInfoRow label="Status" data="Currently Employed" style={{ color: 'green' }} />}
                                </div>
                            </div>
                        </div>
                    </div>

                                <input type="text" name="actionToPerform" id="actionToPerform" hidden value={this.state.userDetails.method} />
                                <input type="text" name="user_type" id="user_type" hidden value={this.state.userDetails.user_type} />
                                <input type="text" name="id" id="id" hidden value={this.state.userDetails.id} />
                                <input type="text" name="image2" id="image2" hidden value={this.state.userDetails.image} />
                                <input type="text" name="scale" id="scale" hidden value={this.state.scale} />
                                <input type="text" name="position_x" id="position_x" hidden value={this.state.x} />
                                <input type="text" name="position_y" id="position_y" hidden value={this.state.y} />
                                <input type="text" name="rotate" id="rotate" hidden value={this.state.rotate} />
                                
                    </form>
                    </div>
                ) : (
                   <p>No Data Found </p>
                )}

            </div>


        );
    }
}

export default EditUserSettings;
